










import { Vue, Component, Prop } from 'vue-property-decorator';
import { IChatParticipant } from '@signing-page/chat/types/chat-participant';
import Avatar from '@/components/Avatar.vue';

@Component({
  components: {
    Avatar,
  },
})
export default class Participant extends Vue {
  @Prop() participant: IChatParticipant;
}
